var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B3954;}\n\t.st1{fill:#16ADE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418,336.1h-19.1c1.5-0.9,2.9-1.9,4.2-3c11.4-9.1,18.7-23.1,18.7-38.9c0-12.2-4.4-23.4-11.7-32.1     c-9.1-10.8-22.7-17.7-38-17.7c-27.5,0-49.7,22.3-49.7,49.7c0,17.6,9.1,33,22.9,41.9h-19.1c-22.7,0-41,18.4-41,41v82.3h33.1V408     c0-3.9,3.1-7,7-7s7,3.1,7,7v51.4H412V408c0-3.9,3.1-7,7-7s7,3.1,7,7v51.4H459v-82.3C459,354.4,440.7,336.1,418,336.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.1,322.9c-4.5-8.8-6.9-18.7-6.9-29c0-35.1,28.6-63.7,63.7-63.7c14.6,0,28.6,5,39.7,13.9l8.8-89.4    c0.7-6.9-4.8-12.9-11.7-12.9H348c-5.6,0-10.4,3.9-11.5,9.4l-7.1,35.1c-1.1,5.5-5.9,9.4-11.5,9.4H64.7c-7.1,0-12.5,6.2-11.7,13.2    l24.3,198.6c0.7,5.9,5.7,10.3,11.6,10.3h181.9v-41C270.9,350.2,289.9,328,315.1,322.9z M248.4,331.1h-32v32h-50.4v-32h-32v-50.3    h32v-32h50.4v32h32V331.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.7,148.5c2.4-12,13-20.7,25.2-20.7h34.3V52.6H91.7v76.6h69c3.9,0,7,3.1,7,7c0,3.9-3.1,7-7,7h-69v38.6      H316L322.7,148.5z M203.1,137.6c-0.1,0.4-0.2,0.9-0.4,1.3c-0.2,0.4-0.4,0.8-0.6,1.2c-0.3,0.4-0.5,0.7-0.9,1.1      c-0.3,0.3-0.7,0.6-1.1,0.9c-0.4,0.3-0.8,0.5-1.2,0.6c-0.4,0.2-0.9,0.3-1.3,0.4c-0.4,0.1-0.9,0.1-1.4,0.1c-1.8,0-3.6-0.8-4.9-2.1      c-1.3-1.3-2.1-3.1-2.1-4.9c0-1.8,0.8-3.6,2.1-5c0.3-0.3,0.7-0.6,1.1-0.9c0.4-0.3,0.8-0.5,1.2-0.6c0.4-0.2,0.9-0.3,1.3-0.4      c0.9-0.2,1.8-0.2,2.7,0c0.4,0.1,0.9,0.2,1.3,0.4c0.4,0.2,0.8,0.4,1.2,0.6c0.4,0.3,0.8,0.5,1.1,0.9c1.3,1.3,2,3.1,2,5      C203.2,136.6,203.2,137.1,203.1,137.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.7b6b473a37ac9e33e781f3c463847d04.svg";
export { ForwardRef as ReactComponent };